module.exports = __webpack_public_path__ + "assets/img/customerService-96a0fdc2.png";